var map = {
	"./01_trade_info.json": "m2cs",
	"./02_last_price.json": "ntfQ",
	"./03_mark_price.json": "D6bT",
	"./04_depth.json": "pvqc",
	"./05_bookTicker.json": "exCQ",
	"./06_kline.json": "p1RX",
	"./07_24hr_ticker.json": "5LXd"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "G8gl";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/cswap/websocket/market \.json$
// module id = G8gl
// module chunks = 3